import useIsMobile from '@/helpers/commonHooks/useIsMobile'
import ResetPwdCardPc from './ResetPwdCardPc/ResetPwdCardPc'
import ResetPwdCardMobile from './ResetPwdCardMobile/ResetPwdCardMobile'

function ResetPwdCard(props: { code: string }) {
  const isMobile = useIsMobile()
  return isMobile ? <ResetPwdCardMobile {...props} /> : <ResetPwdCardPc {...props} />
}

export default ResetPwdCard
